import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'MobileSidemenuButton',
  props: {
  viewingTenant: { type: Boolean, default: false },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["hamburger-container", { banner: __props.viewingTenant }])
  }, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("span", { class: "material-icons text-primary cursor-pointer" }, "menu", -1)
  ]))], 2))
}
}

})